<template lang="pug">
	.pitch-rate-editor.flex-col.space-large
		.flex-col.space
			.font-small.upper.grey {{$tCaption('Predefined')}}
			.flex-row.space
				DxButton(v-for="pred in pitchRates", :key="pred.id", :text="pred.name", :type="predefinedValue === pred.id ? 'default' : 'normal'", @click="() => onPredefinedSet(pred)")
		.flex-col.space
			.flex-row.font-small.upper.grey.space
				span {{$tCaption('Custom')}} 
				span(v-if="!predefinedValue && numberValue !== 0") {{$formatNumber(numberValue, 1).replace(',', '.')}}
			.flex-col.space-medium
				.flex-row.space-large
					.flex-row
						.adt-tab(v-for="rType in relationTypes", :class="{ active: rType.val == isAbsolute }", @click="isAbsolute = rType.val") {{ rType.name }}
					.flex-row
						.adt-tab(v-for="vType in availableValueTypes", :class="{ active: vType === valueType || isAbsolute }", @click="setValueType(vType)") {{ vType.name }}
				.flex-row.space
					DxSlider.flex-1(:min="min", :max="max", :step="step", :value.sync="numberValue", :show-range="false", :tooltip="tooltip")
</template>

<script>
	import DxButton from 'devextreme-vue/button';
	import DxSlider from 'devextreme-vue/slider';

	export default {
		translationCategory: 'insertion.SSMLPitchEditor',
		name: 'pitch-editor',
		components: {
			DxButton, 
			DxSlider
		},
		model: {
			prop: 'value',
			event: 'change '
		},
		props: ['text', 'value'],
		data() {
			const pitchRates = [
				{ id: 'x-low', name: this.$tCaption('Extra low') },
				{ id: 'low', name: this.$tCaption('Low') },
				{ id: 'medium', name: this.$tCaption('Medium') },
				{ id: 'high', name: this.$tCaption('High') },
				{ id: 'x-high', name: this.$tCaption('Extra high') },
				{ id: 'default', name: this.$tCaption('Default') },
			];
			const valueTypes = [
				{ id: '%', name: this.$tCaption('Percent'), min: -100, max: 100  },
				{ id: 'Hz', name: this.$tCaption('Hz'), min: -100, max: 100, supportAbsolute: true  },
				{ id: 'st', name: this.$tCaption('Semitones'), min: -8, max: 8 },
			];
			const relationTypes = [
				{ val: false, name: this.$tCaption('Relative') },
				{ val: true, name: this.$tCaption('Absolute') }
			];
			let predefinedValue = pitchRates.filter(f => f.id === this.value)[0]?.id; 
			return {
				predefinedValue,
				numberValue: parseFloat(this.value) || 0,
				pitchRates,
				isAbsolute: !predefinedValue && this.value && !`${this.value}`.match('[+-]'),
				valueTypes,
				valueType: valueTypes.find(f => this.value && `${this.value}`.indexOf(f.id) > -1) || valueTypes[0],
				relationTypes
			};
		},
		computed: {
			availableValueTypes() {
				return this.isAbsolute ? this.valueTypes.filter(f => f.id === 'Hz') : this.valueTypes;
			},
			min() {
				return this.isAbsolute ? 0 : this.valueType?.min;
			},
			max() {
				return this.isAbsolute ? 2000 : this.valueType?.max;
			},
			step() {
				return 1;
			},
			tooltip() {
				return {
					enabled: true,
					showMode: 'always',
					position: 'bottom',
					formatString: this.valueType?.id,
					format: (v) => `${v}${this.isAbsolute ? 'Hz' : this.valueType?.id}`
				}
			},
			displayValue() {
				return this.predefinedValue ? this.predefinedValue : (this.isAbsolute ? `${this.numberValue}Hz` : `${this.numberValue >= 0 ? '+' : ''}${this.numberValue}${this.valueType.id}`);
			}
		},
		watch: {
			numberValue(v) {
				if (v) {
					this.predefinedValue = null;
				}
			},
			displayValue(v) {
				this.$emit('change', v);
			},
			isAbsolute() {
				this.valueType = this.valueTypes.find(f => f.id === 'Hz');
			}
		},
		mounted() {
			if (__DEBUG__)
				window.pitchEditor = this;
		},
		methods: {
			onPredefinedSet(pred) {
				this.predefinedValue = pred.id;
			},
			setValueType(type) {
				this.valueType = type;
				this.$nextTick(() => {
					this.numberValue = 0;
				});
			}
		}
	};
</script>
<style lang='scss'>
	.pitch-editor {

	}
</style>
